// Module
var code = `<div class="option-paper-positions-panel" {{^.visible}}style="display: none;"{{/}}>
    <div class="option-paper-positions-panel-table-container">
        <quickTableRactive name="optionPaperPositionsTable"/>
    </div>
    <div class ="option-paper-positions-panel-buttons-container">
        <terceraButton name="addUnderlierButton" terceraButtonStyle="js-button-gray25" text="{{addUnderlierButtonText}}" on-btnClick="onAddUnderlierBtnClick"/>
        <terceraButton name="cancelAllButton" terceraButtonStyle="js-button-gray25" text="{{cancelAllButtonText}}" enabled="{{isCancelAllEnabled}}" on-btnClick="onCancelAllBtnClick"/>
        {{#if .shortPositionsAreForbiddenVisibility}}
            <terceraLabel text="{{.shortPositionsAreForbiddenText}}"/>
        {{/if}}
        <terceraButton name="placeSelectedButton" terceraButtonStyle="js-button-blue" text="{{placeSelectedButtonText}}" enabled="{{isPlaceSelectedEnabled}}" on-btnClick="onPlaceSelectedBtnClick"/>
    </div>
</div>`;
// Exports
export default code;